import Lottie from 'lottie-react';
import { FC } from 'react';
import trophyAnimation from './trophy-animation.json';

export const TrophyAnimation: FC<{ loop?: boolean; className?: string }> = ({ loop = false, className }) => {
    return <Lottie animationData={trophyAnimation} loop={loop} className={className} />;
};
